import * as React from 'react'

export const TechWithPurpose = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0'
    y='0'
    viewBox='0 0 210 210'
    xmlSpace='preserve'
  >
    <style>
      {
        '.st0twp{enable-background:new;fill:var(--color-badge-text);}.st3twp,.st4twp{fill:none;stroke:#3c388f;stroke-width:1.25;stroke-miterlimit:9.9999}.st4twp{stroke:var(--color-badge-text);stroke-miterlimit:10}.st8twp{fill:var(--color-badge-text); stroke:var(--color-badge-text)}'
      }
    </style>
    <path
      d='M3.6 107.2 4.8 96l1.6.2-.5 4.7 12.7 1.3-.2 1.8-12.7-1.3-.5 4.7-1.6-.2zM6.4 88.4l2.8-9.7 1.5.4-2.3 8 4.3 1.2 2.1-7.2 1.5.4-2.1 7.2 4.8 1.4 2.4-8.2 1.6.5-2.9 9.9-13.7-3.9zM18.2 74.9c-3.8-1.9-5.6-5.6-3.7-9.4 1.5-3 4.1-3.9 6.6-3.1l-.7 1.6c-1.7-.5-3.5.2-4.5 2.3-1.4 2.8.1 5.5 3.1 7 3.1 1.6 6.1.9 7.4-1.8 1.2-2.4.1-4.4-1.7-5.5l.8-1.6c1.3.7 2.4 2 2.8 3.3.4 1.3.2 2.9-.6 4.5-1.6 3.6-5.6 4.6-9.5 2.7zM21.9 53.4 23 52l4.8 3.7 4.7-6-4.8-3.7 1.1-1.4 11.3 8.7-1.1 1.4-5.3-4.1-4.7 6 5.3 4.1-1.1 1.4-11.3-8.7zM40 33.1l1.5-1.1 7.2 6.2c.8.6 1.8 1.6 1.8 1.6s-.6-1.4-.9-2.3l-3.3-9 1.6-1.1 7.4 6.1c.8.6 1.9 1.7 1.9 1.7s-.6-1.4-1-2.3L52.7 24l1.5-1.1 5.1 13.9-1.4 1L50 31c-.7-.6-1.7-1.5-1.7-1.5s.5 1.3.8 2.1l3.6 9.8-1.5 1L40 33.1zM61.1 19.4l1.6-.8L69 31.5l-1.6.8-6.3-12.9zM69.2 15.6 80 11.9l.5 1.5L76 15l4.1 12-1.7.6-4.1-12-4.5 1.5-.6-1.5zM87.6 10.1l1.8-.3.9 6 7.6-1.1-.9-6 1.8-.3 2 14.2-1.8.3-1-6.7-7.6 1.1 1 6.7-1.8.3-2-14.2zM115.4 8.4l5.9.7c1.5.2 2.6.8 3.2 1.8.5.8.8 1.7.6 2.8-.3 2.6-2 4-5.1 3.6l-3.9-.5-.7 6-1.8-.2 1.8-14.2zm1 7 3.7.4c2 .2 3.1-.7 3.3-2.3.2-1.7-.7-2.7-2.6-2.9l-3.8-.4-.6 5.2zM130.4 20.5l2.8-9.3 1.7.5-2.8 9.1c-.7 2.3.3 3.7 2.6 4.4 2.2.7 3.8.1 4.5-2.3l2.8-9.1 1.7.5-2.8 9.3c-1 3.3-3.7 3.9-6.7 3-3-.8-4.8-2.8-3.8-6.1zM151.5 17.7l5.9 3.1c2.2 1.2 3 3.3 1.9 5.4-.8 1.5-2 2.3-3.8 2v.1c1.1 1.1 1 2.2.2 4.2-.9 2.1-1 2.7-.8 3v.1l-1.7-.9c-.1-.4 0-.9 1-3.1.8-1.9.4-3-1.3-3.9l-3.5-1.8-2.8 5.4-1.6-.8 6.5-12.8zm-1.6 6.8 3.8 2c1.8.9 3.1.5 3.9-.9.8-1.5.5-2.7-1.4-3.7l-3.9-2-2.4 4.6zM167.9 27.1l4.7 3.6c1.2.9 1.8 2 1.9 3.2 0 .9-.2 1.9-.9 2.7-1.6 2.1-3.8 2.4-6.2.5l-3.1-2.4-3.7 4.8-1.4-1.1 8.7-11.3zm-2.7 6.5 3 2.3c1.6 1.2 3 1 4-.3 1-1.4.8-2.7-.7-3.8l-3.1-2.4-3.2 4.2zM176.3 43.2c3.2-2.8 7.4-2.9 10.2.3 2.8 3.2 2.2 7.3-1 10.2-3.2 2.8-7.4 2.9-10.2-.3s-2.2-7.4 1-10.2zm8.1 9.1c2.5-2.2 3.2-5.2 1-7.8s-5.3-2.2-7.8 0-3.2 5.2-1 7.7c2.2 2.6 5.2 2.3 7.8.1zM187 59.8l.9 1.5c-2 1.4-2.3 3.3-1 5.6 1 1.7 2.5 2.5 4 1.6 1.7-1 1.2-2.7.4-5.2-.8-2.4-1.2-4.7 1.1-6 2-1.2 4.2-.2 5.7 2.3 1.8 3.1 1 5.3-1.1 6.9l-.8-1.5c1.6-1.2 1.8-2.9.8-4.7-1-1.7-2.3-2.4-3.6-1.6-1.4.8-1 2.4-.3 4.5.9 2.7 1.6 5.2-1.2 6.8-2.3 1.3-4.7.2-6.2-2.4-2.1-3.4-1.1-6.2 1.3-7.8zM204.2 72.1l3.5 9.5-1.5.5-2.9-7.8-4.2 1.6 2.6 7.1-1.4.5-2.6-7.1-4.7 1.7 3 8-1.6.6-3.6-9.7 13.4-4.9z'
      className='st0twp'
    />
    <path
      d='M98.1 109.3c-1.9 4.1-2.6 8.8-2 13.3.3 3 1.6 5.9 3.6 8.3-.4 1.1 0 3.3.4 5 .4 1.4 1.8 2.3 3.3 1.9h.1c1.7-.5 3.8-1.2 4.6-2.1 3 .6 6.2.2 9-1 4.2-1.7 7.9-4.6 10.5-8.3.5-.7.9-1.3 1.3-2s.8-1.4 1.1-2.1c1.9-4.1 2.6-8.8 2-13.3-.3-3-1.6-5.9-3.6-8.3.4-1.1 0-3.3-.4-5-.4-1.4-1.8-2.3-3.2-1.9h-.1c-1.7.5-3.8 1.2-4.6 2.1-3-.6-6.1-.2-8.9 1-4.3 1.7-7.9 4.6-10.5 8.3-.5.6-.9 1.3-1.3 2-.6.7-.9 1.4-1.3 2.1'
      fill-rule='evenodd'
      clip-rule='evenodd'
      fill='#a5a5ff'
    />
    <path
      d='M88.9 117c.3 3 1.6 5.9 3.6 8.3-.4 1.1 0 3.3.4 5 .4 1.4 1.8 2.3 3.2 1.9h.1c1.7-.5 3.8-1.2 4.6-2.1 3 .6 6.1.2 8.9-1 4.2-1.7 7.9-4.6 10.5-8.3.5-.7.9-1.3 1.3-2s.8-1.4 1.1-2.1c1.9-4.1 2.6-8.8 2-13.3-.3-3.1-1.6-5.9-3.5-8.3.4-1.1 0-3.3-.4-5-.4-1.4-1.8-2.3-3.2-1.9h-.1c-1.7.5-3.8 1.2-4.6 2.1-3-.6-6.1-.2-8.9 1-4.2 1.7-7.9 4.6-10.5 8.3-.5.7-.9 1.3-1.3 2s-.8 1.4-1.1 2.1c-2 4.1-2.7 8.8-2.1 13.3z'
      fill='none'
      stroke='var(--color-badge-text)'
      stroke-width='1.25'
      stroke-miterlimit='10'
    />
    <path
      transform='rotate(-45 108.98041226 74.27091324)'
      className='st3twp'
      d='M106.5 71.8h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 69.61671995 113.7477546)'
      className='st3twp'
      d='M67.2 111.3h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 148.32352085 113.56209766)'
      className='st3twp'
      d='M145.9 111.1h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 108.96041499 152.97299611)'
      className='st3twp'
      d='M106.5 150.5h4.9v4.9h-4.9z'
    />
    <path
      className='st4twp'
      d='M151.3 57.6c30.4 23.9 35.6 67.9 11.7 98.3s-67.9 35.6-98.3 11.7-35.6-68-11.7-98.3c3.4-4.3 7.3-8.3 11.7-11.7'
    />
    <path
      className='st4twp'
      d='M195.9 132c-10.7 48.5-58.7 79.2-107.3 68.5-27.9-6.2-51.2-25.2-62.8-51.3'
    />
    <path
      className='st8twp'
      transform='matrix(.9991 -.04222 .04222 .9991 -4.4176 8.4532)'
      d='M195.9 106.8h4v4h-4z'
    />
    <path
      className='st8twp'
      transform='rotate(-9.32 19.19196554 127.1924224)'
      d='M17.2 125.2h4v4h-4z'
    />
  </svg>
)

export default TechWithPurpose
